import { Component, Input } from '@angular/core';

@Component({
  selector: 'pos-app-spinner2',
  template: `
    <pos-app-spinner
      [show]="show"
      [partial]="partial"
      [inline]="true"
      [showTextLoader]="showTextLoader"
      [displayText]="displayText"
      [dark]="dark"
    ></pos-app-spinner>
  `,
  styles: [],
  standalone: false
})
export class Spinner2Component {
  // Spinner2 is intended for inline use — default to show when component exists
  @Input() show: boolean = true;
  @Input() partial: boolean = true;
  @Input() showTextLoader: boolean = false;
  @Input() displayText: string = '';
  @Input() dark: boolean = false;
}

